var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_ec_cube.html';
var html = "<ng-container translate=sites.campaigns.edit.instruction.ecCube translate-value-link=\"<a href='http://www.ec-cube.net/products/detail.php?product_id=470' target='_blank'>{{ 'sites.campaigns.edit.instruction.ecCubeLink' | translate }}</a>\"></ng-container>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/instruction_ec_cube.html
// module id = 1391
// module chunks = 0